'use client';

import { useContext, useEffect, useState } from 'react';

import { ReportContext } from '@/app/providers/reportProvider';
import { useTranslations } from 'next-intl';
import dynamic from 'next/dynamic';
const SampleButton = dynamic(() => import('./sample-button'));
const BuyButton = dynamic(() => import('./buy-now-btn'));

export default function BottomButtons() {
  const [isActive, setIsTocActive] = useState(false);
  const report = useContext(ReportContext);
  const regionalText = useTranslations('mobile_btns');

  useEffect(() => {
    function onScroll() {
      const section = document.getElementById('title-banner');
      const secHeight = section && section.clientHeight;

      if (window.scrollY >= secHeight) {
        setIsTocActive(true);
      } else {
        setIsTocActive(false);
      }
    }

    window.addEventListener('scroll', onScroll);

    return () => window.removeEventListener('scroll', onScroll);
  }, [report]);

  return (
    <div className={`fixed-botton ${isActive ? 'active' : ''}`}>
      <div className="fixed-buttons-groups flex flex-row text-center justify-center items-center">
        <div className="buy-now grow border-red-500 bg-white text-red-500 h-11 p-1 text-center border-2">
          <BuyButton text={regionalText('buy_now')} />
        </div>
        <div className="customize-now grow">
          <SampleButton className="text-red-600" formName={'Sample'}>
            {regionalText('get_sample')}
          </SampleButton>
        </div>
      </div>
    </div>
  );
}
